import 'ui-core/components/article-actions-bar/js/article-action-bar';
const articleActionsbar = UX.articleActionsbar;

articleActionsbar.controls = function () {
    articleActionsbar.selectElement = document.querySelector('#actionsList');
    articleActionsbar.viewAbstract = articleActionsbar.form.querySelectorAll('.accordion__control');
    if (config.enableArticleActionbarSelectAll) {
        articleActionsbar.selectAllBox.addEventListener('click', function () {
            const isChecked = this.checked;
            articleActionsbar.checkboxes.forEach(item => (item.checked = isChecked));
            articleActionsbar.showHideActionBtns();
        });
    }

    articleActionsbar.checkboxes.forEach(elem => {
        elem.addEventListener('click', () => {
            articleActionsbar.selectAllBox.checked = articleActionsbar.allItemsSelected();
            articleActionsbar.showHideActionBtns();
        });
    });
    $(articleActionsbar.selectElement).on('change click touchend blur', function (e) {
        const _this = this;
        if (_this.value === 'showHide') {
            if (articleActionsbar.selectAllBox.checked === true) {
                articleActionsbar.viewAbstract.forEach(item => {
                    item.click();
                });
            } else if (articleActionsbar.hasSelectedItems) {
                articleActionsbar.checkboxes.forEach(item => {
                    if (item.checked) {
                        $(item).closest('.search-item').find('.accordion__control').click();
                    }
                });
            }
            articleActionsbar.selectElement.selectedIndex = 0;
        } else if (_this.value !== '0') {
            articleActionsbar.form.action = _this.value;
            articleActionsbar.form.submit();
            articleActionsbar.selectElement.selectedIndex = 0;
        }
    });
};
